__turbopack_context__.v({
  "className": "lato_3110021d-module___-IdIG__className",
});
